angular.module('app.filters')
.filter('jobsInTargetLocations', [
  '$log', 'sharedProperties', function($log, sharedProperties) {
    return function(firmList, targetLocation) {
      firmList.forEach(function(firm, index, array) {
        firm.selected_jobs = [];
        firm.available_jobs.forEach(function(job, j_index, array) {
          if (job.ref_locations) {
            return job.ref_locations.forEach(function(rloc, index, array) {
              if (sharedProperties.isNotNullOrEmpty(_.find(targetLocation, function(loc) {
                return loc.loc_name === rloc.loc_name;
              }))) {
                firm.selected_jobs.push(job);
              }
            });
          }
        });
        firm.available_jobs = angular.copy(firm.selected_jobs);
      });
      return firmList;
    };
  }
]);


// WEBPACK FOOTER //
// ./scripts/shared/filters/jobs-in-target-locations.js